export const LODGE_FOUNDING_YEAR = 1850;

export function getLodgeAnniversaryYears(date = new Date()): number {
  return date.getFullYear() - LODGE_FOUNDING_YEAR;
}
